import { useArticlePublishMutation } from 'lib-knowledge-management-common/graphql';
import { ampli } from 'lib-shared-tracking';

type MutationFunction = ReturnType<typeof useArticlePublishMutation>[0];
type MutationReturnValue = ReturnType<MutationFunction>;

export type PublishFn = () => MutationReturnValue;

type UseTranslationPublishReturnValue = [
  PublishFn,
  ReturnType<typeof useArticlePublishMutation>[1],
];

type UseTranslationPublishOptions = {
  articleId: string;
};

export function useArticlePublish({
  articleId,
}: UseTranslationPublishOptions): UseTranslationPublishReturnValue {
  const [publishFn, mutationResult] = useArticlePublishMutation();
  const publish: PublishFn = async () => {
    return publishFn({
      variables: {
        articleId,
      },
      refetchQueries: ['ArticleTranslation'],
    }).then((args) => {
      ampli.knowledgeArticlePublished({ articleId });
      return args;
    });
  };

  return [publish, mutationResult];
}
